import React from 'react'
import { useNavigate } from 'react-router-dom'

import { useMutation } from '@percent/admin-dashboard/common/hooks'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { ChangeTwoFactorDevice } from './ChangeTwoFactorDevice'
import { ChangeTwoFactorDeviceContainerProps } from './ChangeTwoFactorDevice.types'

export function ChangeTwoFactorDeviceContainer({ isOpened, onClose }: ChangeTwoFactorDeviceContainerProps) {
  const navigate = useNavigate()
  const { authService } = useServices()

  const [{ isLoading, errorMessage }, { apiFunc: generateQRToken }] = useMutation(authService.generateQRCode, data => {
    if (data?.data?.data?.otpKey) {
      navigate('/login/2fa-setup', { state: { otpData: data?.data?.data } })
    }
  })

  return (
    <ChangeTwoFactorDevice
      generateQRToken={generateQRToken}
      errorMessage={errorMessage}
      isOpened={isOpened}
      isLoading={isLoading}
      onClose={onClose}
    />
  )
}
